module.exports = __webpack_public_path__ + "img/publicSecurity.07912576.png";